import { StyleSheet } from 'react-native';

const globalStyle = StyleSheet.create({
	buttonMargins: {
		marginBottom: 25,
		marginHorizontal: 15
	},
	buttonFixedDown: {
		marginBottom: 25
	},
	buttonMain2: {
		padding: 8,
		borderRadius: 15,
		backgroundColor: '#2196f3'
	},
	buttonMain: ({ pressed }) => [
		{
			backgroundColor: pressed ? '#0961aa' : '#2597f4',
			padding: 12,
			borderRadius: 25,
			elevation: 1, // add a shadow on Android
			opacity: 1
			//opacity: pressed ? 0.3 : 1
		}
	],
	buttonStart: ({ pressed }) => [
		{
			backgroundColor: pressed ? '#580e58' : '#841584',
			padding: 15,
			borderRadius: 10,
			elevation: 1,
			opacity: 1
		}
	],
	buttonDelete: ({ pressed }) => [
		{
			backgroundColor: pressed ? '#990000' : '#e60000',
			padding: 15,
			borderRadius: 5,
			opacity: 1
		}
	],
	buttonMigrate: ({ pressed }) => [
		{
			backgroundColor: pressed ? '#b35900' : '#ff8000',
			padding: 15,
			borderRadius: 5,
			opacity: 1
		}
	],
	buttonMainDisabled: () => [
		{
			backgroundColor: '#dfdfdf',
			padding: 12,
			borderRadius: 25
		}
	],
	buttonStartDisabled: () => [
		{
			backgroundColor: '#dfdfdf',
			padding: 15,
			borderRadius: 10,
			elevation: 1
		}
	],
	buttonMatch: ({ pressed }) => [
		{
			backgroundColor: pressed ? '#248f24' : '#33cc33',
			padding: 10,
			borderRadius: 10,
			marginHorizontal: 10,
			opacity: 1
		}
	],
	buttonMatchStats: ({ pressed }) => [
		{
			backgroundColor: pressed ? '#86592d' : '#bf8040',
			padding: 10,
			borderRadius: 10,
			marginHorizontal: 10,
			opacity: 1
		}
	],
	buttonTable: {
		backgroundColor: '#e6e6e6'
	},
	buttonMatchDisabled: {
		backgroundColor: '#dfdfdf',
		padding: 10,
		borderRadius: 10,
		marginHorizontal: 10
	},
	textForButtonMain: {
		color: '#fff',
		textAlign: 'center',
		textTransform: 'uppercase',
		fontWeight: '500'
	},
	textForButtonMainDisabled: {
		color: '#a1a1a1',
		textAlign: 'center',
		textTransform: 'uppercase',
		fontWeight: '500'
	},
	textForButtonTable: {
		textAlign: 'center',
		fontWeight: 'bold',
		fontSize: 13
	},
	textForTitleScreen: {
		color: '#000',
		textAlign: 'center',
		textTransform: 'uppercase',
		fontWeight: '500',
		fontSize: 36,
		fontWeight: 'bold'
	},
	textH2: {
		color: '#000',
		textAlign: 'center',
		fontWeight: '500',
		fontSize: 24,
		fontWeight: 'bold'
	},
	buttonChangePlayer: ({ pressed }) => [
		{
			backgroundColor: '#4d4d4d',
			padding: 12,
			marginLeft: 'auto',
			marginRight: 'auto',
			width: 40,
			height: 40,
			borderRadius: 50,
			opacity: pressed ? 0.5 : 1
		}
	],
	buttonChangingPlayer: ({ pressed }) => [
		{
			backgroundColor: '#262626',
			padding: 12,
			marginLeft: 'auto',
			marginRight: 'auto',
			width: 40,
			height: 40,
			borderRadius: 50,
			opacity: pressed ? 0.5 : 1
		}
	],
	buttonSellPlayer: ({ pressed }) => [
		{
			backgroundColor: '#85bb65',
			paddingHorizontal: 10,
			paddingVertical: 2,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 5,
			opacity: pressed ? 0.5 : 1
		}
	],
	centerContentWithLateralMargin: {
		marginHorizontal: 25,
		marginBottom: 'auto',
		marginTop: 'auto',
	},
	centerContentForTitle: {
		marginHorizontal: 25,
		marginBottom: 'auto',
		marginTop: 'auto',
		position: 'absolute',
		left: 0,
		right: 0,
		top: '15%',
		bottom: 0
	},
	cardHalfScreen: {
		margin: 20,
		paddingVertical: 20,
		paddingHorizontal: 30,
		backgroundColor: '#ffffff',
		elevation: 1,
		borderRadius: 20
	},
	cardHalfScreenPressable: ({ pressed }) => [
		{
			margin: 20,
			paddingVertical: 20,
			paddingHorizontal: 30,
			backgroundColor: pressed ? '#d9d9d9': '#ffffff',
			elevation: 1,
			borderRadius: 20
		}
	],
	input: {
		height: 40,
		margin: 12,
		borderWidth: 0.5,
		padding: 10,
		borderRadius: 5,
		backgroundColor: 'white'
	},
	centerHorizontally: {
		marginRight:'auto',
		marginLeft:'auto'
	}
});

export default globalStyle